import routerConfig from '@/router/config'

export default {
    //路由配置
    routerConfig,
    //舞台深度
    sideBarLevel: 3,
    // 權限和當前用戶信息
    permissions: [],
    user: { admin: true },
    //主題
    themeName: 'light',
    language: '',
    //這裡上面的需要保存到localstorage
    //屏幕寬度
    resize: null,
}